<template>
    <section v-if="!loading && resultsCount === 0" class="OrganisationsNoResultsContainer">
		<img
			src="//monet-prtl-co.imgix.net/Shared/SearchPage/Ghost.svg"
			class="OrganisationsNoResultsImage"
			alt="No results found"
		/>
		<div class="OrganisationsNoResultsText">
			<strong class="OrganisationsNoResultsHeading">No results</strong>
			<p class="OrganisationsNoResultsDetails">
				But we've got a lot more! Modify your filters or make a
				<button class="OrganisationsResetFilters" type="button" @click="clearAllFilters()">fresh start</button>
			</p>
		</div>
	</section>
</template>

<script setup lang="ts">
import { useSearchStore } from '@app/stores/useSearchStore';
import { computed } from 'vue';

const searchStore = useSearchStore();

const resultsCount = computed(() => searchStore.pageData?.totalResultsCount ?? 0);
const loading = computed(() => searchStore.loading || searchStore.pageData?.results === undefined);

const clearAllFilters = async (): Promise<void> => {
    await searchStore.cleanFilters();
};
</script>

<style scoped lang="scss">
.OrganisationsNoResultsContainer {
	background-color: $White;
	display: flex;
	border-radius: 0.5rem;
    @include PaddingAreas(1);
	@include MarginAreas(1, 0, 0, 0);

	@include Breakpoint(ExtraLarge) {
		@include MarginAreas(3, 3);
	}

	.OrganisationsNoResultsText {
		border-left: 1px $Grey-200 solid;
		display: flex;
		flex-direction: column;
		justify-content: center;
        @include MarginAreas(0, 0, 0, 1);
		@include PaddingAreas(0, 0, 0, 1);
	}

	.OrganisationsNoResultsHeading {
		display: block;
		@include TextStyle(HeadingExtraSmall);
		@include MarginAreas(0, 0, 0.5, 0);

		@include Breakpoint(Large, ExtraLarge) {
			@include MarginAreas(0, 0, 1, 0);
			@include TextStyle(HeadingMedium);
		}
	}

	.OrganisationsNoResultsDetails {
		@include TextStyle(BodySmallRegular);
		@include MarginAreas(0);

		@include Breakpoint(Large, ExtraLarge) {
			@include TextStyle(BodyRegular);
		}
	}

	.OrganisationsResetFilters {
		border: 0;
		color: $Blue-700;
		cursor: pointer;
		background: transparent;
        @include PaddingAreas(0);
		@include TextStyle(BodySmallRegular);

		&:hover {
			text-decoration: underline;
		}

        @include Breakpoint(Large, ExtraLarge) {
			@include TextStyle(BodyRegular);
		}
	}
}
</style>